import { DISCOUNT_SOFTENING_PROMO_CODE_DATA_V5, PROMO_CODE_DATA } from '../homeConfig'
import { useDiscountSofteningV5 } from '../useDiscountSofteningV5'

export function usePromoBannerText() {
  const isEnabled = useDiscountSofteningV5()

  return isEnabled ? DISCOUNT_SOFTENING_PROMO_CODE_DATA_V5 : PROMO_CODE_DATA
}
